import React, { useState } from "react";
import "./AddAdminFingerprint.css";
import verificationImg from "../../assets/Verification.png"; // your fingerprint PNG

const AddAdminFingerprint = () => {
  const [enteredId, setEnteredId] = useState("");
  const [message, setMessage] = useState("");
  const [adminDetails, setAdminDetails] = useState(null);
  const [step, setStep] = useState("enterId"); // enterId | confirm | fingerprint

  const handleNumberClick = (num) => setEnteredId((prev) => prev + num);
  const handleClear = () => setEnteredId("");
  const handleDelete = () => setEnteredId((prev) => prev.slice(0, -1));

  const handleSubmit = () => {
    if (enteredId === "1234") { // dummy admin ID
      setAdminDetails({ name: "John Doe", role: "Super Admin", id: enteredId });
      setMessage("");
      setStep("confirm");
    } else {
      setMessage("❌ Invalid Admin ID");
      setAdminDetails(null);
    }
  };

  const handleConfirm = () => setStep("fingerprint");

  const handleCancel = () => window.history.back();

  // New: handle fingerprint click
  const handleFingerprintClick = () => {
    setMessage("✅ Admin fingerprint successfully added!");
    setTimeout(() => {
      window.location.href = "/"; // redirect to home page after 3 sec
    }, 3000);
  };

  return (
    <div className="fingerprint-container">

      {/* Step 1: Enter Admin ID */}
      {step === "enterId" && (
        <div className="fingerprint-id-box">
          <h2 className="fingerprint-title">Enter Admin ID</h2>
          <div className="fingerprint-id-display">{enteredId || "—"}</div>
          {message && <div className="fingerprint-message">{message}</div>}

          <div className="fingerprint-number-pad">
            {[1,2,3,4,5,6,7,8,9,0].map((num) => (
              <button
                key={num}
                className="fingerprint-number-key"
                onClick={() => handleNumberClick(num)}
              >
                {num}
              </button>
            ))}
            <button className="fingerprint-number-key clear" onClick={handleClear}>Clear</button>
            <button className="fingerprint-number-key delete" onClick={handleDelete}>⌫</button>
          </div>

          <div className="fingerprint-buttons-row">
            <button onClick={handleSubmit} className="fingerprint-submit-btn">Submit</button>
            <button onClick={handleCancel} className="fingerprint-cancel-btn">Cancel</button>
          </div>
        </div>
      )}

      {/* Step 2: Confirm Admin Details */}
      {step === "confirm" && adminDetails && (
        <div className="fingerprint-profile-box">
          <h2 className="fingerprint-title">Admin Found</h2>
          <p><strong>Name:</strong> {adminDetails.name}</p>
          <p><strong>Role:</strong> {adminDetails.role}</p>
          <p><strong>ID:</strong> {adminDetails.id}</p>

          <div className="fingerprint-confirm-row">
            <button className="fingerprint-cancel-btn" onClick={handleCancel}>Cancel</button>
            <button className="fingerprint-confirm-btn" onClick={handleConfirm}>Confirm</button>
          </div>
        </div>
      )}

      {/* Step 3: Fingerprint */}
      {step === "fingerprint" && (
        <div className="fingerprint-add-box">
          <h2 className="fingerprint-title">Place Admin Finger</h2>
          <img
            src={verificationImg}
            alt="Verification"
            className="fingerprint-img"
            onClick={handleFingerprintClick} // click to add fingerprint
          />
          {message && <div className="fingerprint-message success">{message}</div>}
        </div>
      )}

    </div>
  );
};

export default AddAdminFingerprint;
